export var coinsById = function (id, FOR_VK, FOR_YANDEX) {
    if (FOR_VK === void 0) { FOR_VK = false; }
    if (FOR_YANDEX === void 0) { FOR_YANDEX = false; }
    if (FOR_VK) {
        if (id === '1' || id === '101')
            return 5000;
        if (id === '2' || id === '102')
            return 15000;
        if (id === '3' || id === '103')
            return 25000;
    }
    if (FOR_YANDEX) {
        if (id === '1' || id === '101')
            return 5000;
        if (id === '2' || id === '102')
            return 15000;
        if (id === '3' || id === '103')
            return 25000;
    }
    return Number(id);
};
